import React, { Fragment, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { LearnerProgress } from "@hubcapp/types";
import {
  learnerActions,
  selectAllSkills,
  selectProgress,
} from "@hubcapp/state";
import { useTealium } from "@hubcapp/context";

import { StateProviderProps } from "./types";
import Progress from "./LearnerProgress";
import getLearnerProgressQuery from "./graph-ql/getLearnerProgress.graphql";
import useGetLearnerProgress from "./hooks/useGetLearnerProgress";
import useMutationUpdateLearnerProgress from "./hooks/useUpdateLearnerProgress";

const LessonsTableStateProvider: React.FC<StateProviderProps> = ({
  learnerId,
}) => {
  const dispatch = useDispatch();
  const updatedLearnerProgress = useSelector(selectProgress);
  const allSkills = useSelector(selectAllSkills);

  const { data, loading } = useGetLearnerProgress(learnerId);

  const [updateLearnerProgress] = useMutationUpdateLearnerProgress({
    onCompleted: () => {
      dispatch(learnerActions.progressSaved());
    },
    refetchQueries: [
      {
        query: getLearnerProgressQuery,
        variables: {
          id: learnerId,
        },
      },
    ],
    awaitRefetchQueries: true,
  });

  useEffect(() => {
    dispatch(
      learnerActions.progressUpdated({
        progress: data?.learner?.progress as LearnerProgress,
      }),
    );
    dispatch(learnerActions.progressSaved());
  }, [data]);

  const { trackEvent } = useTealium();

  const handleSaveLearnerProgressClick = () => {
    trackEvent({
      eventCategory: "View Learner - Learner Progress",
      eventAction: "Button Click",
      eventLabel: "Save Learner Progress",
    });
    updateLearnerProgress({
      variables: {
        learnerId,
        skills: (allSkills || []).map(skill => ({
          id: skill?.id,
          score: skill?.score,
        })),
      },
    });
  };

  return (
    <Fragment>
      <Progress
        loading={loading}
        learnerProgress={updatedLearnerProgress}
        onSaveClick={handleSaveLearnerProgressClick}
      />
    </Fragment>
  );
};

export default LessonsTableStateProvider;
